import { ia, iaRa } from 'lib/helpers/utility';

import TableBodyHeader from '../TableBodyHeader';
import TableContent from '../TableContent';

const TableGfeInvoices = ({
  title,
  description,
  visibleCols,
  invoices,
  actions,
  preview,
  openModal,
  invoice: originalInvoice,
  CustomRowHeader,
  checkin,
  variant,
  icon,
  headerBodyClassName
}) => {
  if (!ia(invoices)) return null;

  return (
    <>
      <>
        {!checkin && (
          <tr>
            <th colSpan={visibleCols.length} className="p-0">
              <TableBodyHeader
                columnDefs={visibleCols}
                value={title}
                description={description}
                icon={icon}
                actions={actions}
                variant={variant}
                bodyClassName={headerBodyClassName}
              />
            </th>
          </tr>
        )}
      </>
      {iaRa(invoices).map(([invoiceId, invoice], idx) => (
        <TableContent
          key={invoiceId}
          invoiceId={invoiceId}
          visibleCols={visibleCols}
          rows={invoice.rows}
          dateofservice={invoice.dateofservice}
          idx={idx}
          preview={preview}
          openModal={openModal}
          invoice={originalInvoice}
          CustomRowHeader={CustomRowHeader}
          checkin={checkin}
          variant={variant}
        />
      ))}
    </>
  );
};

export default TableGfeInvoices;
